<template>
  <section :id="sectionId" class="wagb-home__install">
    <header class="wagb-home__install-header">
      <h2 class="wagb-home__install-title">{{ title }}</h2>
      <p class="wagb-home__install-subtitle">{{ section.subtitle }}</p>
      <div class="wagb-home__install-divider" aria-hidden="true">
        <span />
      </div>
    </header>

    <div class="wagb-home__install-track">
      <template v-for="(step, idx) in steps">
        <article :key="step.title" class="wagb-home__install-step">
          <span class="wagb-home__install-badge">{{ formatStep(idx + 1) }}</span>
          <h3 class="wagb-home__install-step-title">{{ step.title }}</h3>

          <div class="wagb-home__install-phone">
            <img :src="step.image" :alt="step.title" width="220" height="380" loading="lazy" />
          </div>

          <ul class="wagb-home__install-list">
            <li v-for="item in step.items" :key="item">{{ item }}</li>
          </ul>
        </article>

        <div
          v-if="idx < steps.length - 1"
          :key="'arrow-' + idx"
          class="wagb-home__install-arrow"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              d="M9 6l6 6-6 6"
            />
          </svg>
        </div>
      </template>
    </div>

    <div class="wagb-home__install-notes">
      <div class="wagb-home__install-note wagb-home__install-note--info">
        <span class="wagb-home__install-note-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="28" height="28">
            <path
              fill="#25d366"
              d="M12 2 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-3zm-1 14h2v2h-2v-2zm0-8h2v6h-2V8z"
            />
          </svg>
        </span>
        <div>
          <h4>{{ section.noteCard.title }}</h4>
          <ul>
            <li v-for="item in section.noteCard.items" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>

      <div class="wagb-home__install-note wagb-home__install-note--warn">
        <span class="wagb-home__install-note-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="28" height="28">
            <path fill="#f59e0b" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
        </span>
        <div>
          <h4>{{ section.alertCard.title }}</h4>
          <p>{{ section.alertCard.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InstallGuideSection',
  props: {
    sectionId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    section: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatStep(num) {
      return String(num).padStart(2, '0');
    },
  },
};
</script>
